// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-flow-width-horizontal-label {
    text-anchor: middle;
    font-size: 13px;
    /* fill: #3a3a3a */
}`, "",{"version":3,"sources":["webpack://./src/css/legend/flow.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".em-flow-width-horizontal-label {\r\n    text-anchor: middle;\r\n    font-size: 13px;\r\n    /* fill: #3a3a3a */\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
